import GeoCellLayer from "../geo-cell-layer/GeoCellLayer.js";
import { getGeohashPolygon } from "./geohash-utils.js";
const defaultProps = {
    getGeohash: { type: 'accessor', value: (d) => d.geohash }
};
/** Render filled and/or stroked polygons based on the [Geohash](https://en.wikipedia.org/wiki/Geohash) geospatial indexing system. */
export default class GeohashLayer extends GeoCellLayer {
    static { this.layerName = 'GeohashLayer'; }
    static { this.defaultProps = defaultProps; }
    indexToBounds() {
        const { data, getGeohash } = this.props;
        return {
            data,
            _normalize: false,
            positionFormat: 'XY',
            getPolygon: (x, objectInfo) => getGeohashPolygon(getGeohash(x, objectInfo))
        };
    }
}
